import { http } from '@/core/helpers/http.helper';
import { CandidatesBulkSms, CandidatesBulkSmsResponse } from './candidates-bulk-sms.interface';

export class CandidatesBulkSmsService {
   async sendCandidatesBulkSms(candidatesBulkSms: CandidatesBulkSms) {
      const response = await http.post<CandidatesBulkSmsResponse>(`/candidates-bulk-sms`, candidatesBulkSms);
      return response.data;
   }
}
